import { useNavigate } from 'react-router-dom';

export function useAuth() {
    const navigate = useNavigate();

    const signOut = () => {
        // Clear all auth-related data from localStorage
        localStorage.clear();
        // Clear sessionStorage as well
        sessionStorage.clear();
        // Redirect to login
        navigate('/login');
        // Force a page reload to clear any cached state
        window.location.reload();
    };

    // Get user data from localStorage or your auth system
    const user = {
        name: localStorage.getItem('userName') || 'Rise Finance',
        email: localStorage.getItem('userEmail') || 'Painel de Controle'
    };

    return {
        user,
        signOut
    };
} 